import React, { useEffect, useCallback, Fragment } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';
import ModalComponent, { ModalBody, ModalFooter } from 'Components/Modal';

import { Grid } from '@mui/material';
import { Tooltip } from '@gpstrackit/gtc-react-controls';

import {
    modalPingClose,
    clearRedux
} from 'Redux/actions'

const ModalPing = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { isOpen, loadingPing, pingResponse, units } = useSelector(state => state.vehiclePingRedux);

    const handleClose = useCallback(() => {
        dispatch(modalPingClose())
    })

    useEffect(() => {
        if (!pingResponse) {
            NotificationManager.error(
                messages['fleet_ping_error_message'],
                messages['fleet_ping_error_title'],
                3000,
                null,
                null,
                'error',
                null
            );

            dispatch(clearRedux("MODAL_PING"))
        }

    }, [pingResponse]);


    const renderLabel = (label = '') => {
        if(label < 20) return label
        return(
            <Tooltip title={label} placement='top'>
				<p>{label?.slice(0, 20)}...</p>
			</Tooltip>
        )
    }


    return (
        <ModalComponent
            open={isOpen}
            handleClose={handleClose}
            title={messages['fleet_ping_modal_title']}
            position="right"
            size="small"
            loading={loadingPing}
        >
            <ModalBody>
                <div style={{ padding: 24 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        style={{ marginBottom: 20 }}
                        spacing={1}
                    >
                        <Grid item xs={7}>
                            <b>{messages['fleet_ping_vehicles']}</b>
                        </Grid>
                        <Grid item xs={5}>
                            <b>{messages['fleet_starter_status']}</b>
                        </Grid>
                    </Grid>

                    {
                        units && units.map((unit, index) => {
                            return (
                                <Grid
                                    key={index}
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    style={{ display: 'flex', alignItems: 'center', margin: "10px 0px 10px 0px" }}
                                    spacing={1}
                                >
                                    <Grid item xs={7}>
                                        {renderLabel(unit.label)}
                                    </Grid>
                                    <Grid item xs={5}>
                                        <ShowPingState unit={unit} loadingPing={loadingPing} messages={messages} pingResponse={pingResponse} />
                                    </Grid>
                                </Grid>
                            );
                        })
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        id={'btn-cancel-alternative'}
                        type="button"
                        onClick={handleClose}
                        className="btn-cancel btn-cancel-alternative"
                    >
                        {messages['close']}
                    </Button>
                </div>
            </ModalFooter>
        </ModalComponent>
    );
};

export default ModalPing;

const ShowPingState = ({ unit, loadingPing, messages, pingResponse }) => {
    let color = '';
    let message = '';

    if (loadingPing == true) {
        color = 'gray'
        message = messages["fleet_ping_loading"]

    }
    else {
        if (loadingPing == false && pingResponse == null) {
            color = 'red'
            message = messages["fleet_ping_error_title"]
        }
        else {
            const pResponse = pingResponse.filter(response => String(response.unitId) === String(unit.id))[0]

            if (!pResponse) {
                color = 'gray'
                message = messages["fleet_ping_unknown"]
            }
            else {
                if (pResponse.outId > -1) {
                    color = 'green'
                    message = messages["fleet_ping_success"]
                }
                else if (pResponse?.errorMessage) {
                    color = 'orange'
                    message = messages[pResponse.errorMessage] || pResponse.errorMessage
                }
                else {
                    color = 'orange'
                    message = messages["fleet_ping_unreachable"]
                }
            }

        }
    }

    return <span style={{ color }} >{message}</span>
};